import { useAppContext } from '@Containers/AppContainer';
import Gql from '@Core/Gql';
import User from '@Modules/User/User';
import gql from "graphql-tag";
import React, { createContext, ReactNode, useContext, useState } from 'react';
import { NavigateFunction } from "react-router";

const LOGOUT_QUERY = gql`
    mutation { logout }
`;

let LOGGED_IN = false;

export function isLoggedIn() {
    return LOGGED_IN;
}

export function setLoggedIn(loggedIn: boolean = true) {
    LOGGED_IN = loggedIn;
}

export interface SessionContextInterface {
    logout(navigate: NavigateFunction): Promise<void>;
    setUser(user: User): void;
    user?: null | User;
}

const SessionContext = createContext<SessionContextInterface>({
    logout: async () => {},
    setUser: () => {},
    user: null
});

export function useSessionContext() {
    return useContext(SessionContext);
}

export default function SessionContainer({ children }: { children: ReactNode }) {
    const [user, setUser] = useState<User|undefined>();
    const { setLoading } = useAppContext();

    const logout = async (navigate: NavigateFunction) => {
        const { logout } = await Gql().request<{logout: boolean}>(LOGOUT_QUERY);

        if (logout) {
            setLoading(true);
            LOGGED_IN = false;
            setUser(undefined);

            navigate('/login');
            setLoading(false);
        }
    };

    return (
        <SessionContext.Provider value={{ logout, user, setUser }}>
            {children}
        </SessionContext.Provider>
    );
}
